import type { PaletteOptions } from '@mui/material/styles';

/**
 * BeMoTechs brand palette - Light mode
 *
 * Primary (Warm Orange) derived from the cat mascot logo.
 * Secondary (Dark Sage) derived from the logo text.
 * Accent (Teal) used for informational highlights.
 */
export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#E07A3F',
    light: '#F0A06B',
    dark: '#C4612A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#5A6460',
    light: '#7A8A85',
    dark: '#3D4542',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#2E7D32',
    light: '#4CAF50',
    dark: '#1B5E20',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#ED6C02',
    light: '#FF9800',
    dark: '#E65100',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#C62828',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#0288D1',
    light: '#03A9F4',
    dark: '#01579B',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#F5F5F0',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#1A1E1D',
    secondary: '#5A6460',
    disabled: '#9E9E9E',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
};

/**
 * BeMoTechs brand palette - Dark mode
 *
 * Maintains the same brand hues but adjusts lightness and saturation
 * for comfortable reading on dark backgrounds.
 */
export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#F0A06B',
    light: '#F5BD95',
    dark: '#E07A3F',
    contrastText: '#1A1E1D',
  },
  secondary: {
    main: '#7A8A85',
    light: '#A0ACA8',
    dark: '#5A6460',
    contrastText: '#1A1E1D',
  },
  success: {
    main: '#66BB6A',
    light: '#81C784',
    dark: '#388E3C',
    contrastText: '#1A1E1D',
  },
  warning: {
    main: '#FFA726',
    light: '#FFB74D',
    dark: '#F57C00',
    contrastText: '#1A1E1D',
  },
  error: {
    main: '#EF5350',
    light: '#E57373',
    dark: '#D32F2F',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#29B6F6',
    light: '#4FC3F7',
    dark: '#0288D1',
    contrastText: '#1A1E1D',
  },
  background: {
    default: '#1A1E1D',
    paper: '#242928',
  },
  text: {
    primary: '#F5F5F0',
    secondary: '#A0ACA8',
    disabled: '#6B7572',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
};
